"use strict";

var Sortable = require('./Sortable').default;

module.exports = Sortable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sortablejs/lib/index.js
// module id = 618
// module chunks = 9